'use client';
import { Megaphone, X } from 'lucide-react';
import Link from 'next/link';
// import { useEffect, useState } from 'react';

const ToneHuntBanner = () => {
  // const [isVisible, setIsVisible] = useState(false);

  // useEffect(() => {
  //   // Check local storage on mount
  //   const isBannerDismissed = localStorage.getItem('tonehuntBannerDismissed');
  //   if (isBannerDismissed) {
  //     setIsVisible(false);
  //   } else {
  //     setIsVisible(true);
  //   }
  // }, []);

  // const handleDismiss = () => {
  //   setIsVisible(false);
  //   localStorage.setItem('tonehuntBannerDismissed', 'true');
  // };

  // if (!isVisible) return null;

  const handleDismiss = () => {
    // TODO: Implement dismiss logic
  };

  return (
    <div style={{ background: '#0000D0' }} className={'relative hidden'}>
      <div
        className={
          'max-w-6xl px-3 sm:px-6 mx-auto flex flex-row gap-4 py-2 justify-center items-center'
        }
      >
        <Megaphone />
        <span className="flex flex-row gap-2 text-sm sm:text-base">
          ToneHunt is now TONE3000
          <Link onClick={handleDismiss} href="/blog/tonehunt-is-now-tone3000" className="underline">
            Read blog
          </Link>
        </span>
        {/* <button
          onClick={handleDismiss}
          className="sm:absolute right-2 top-1/2 sm:-translate-y-1/2 p-1 text-zinc-200 hover:text-white"
          aria-label="Dismiss banner"
        >
          <X size={20} />
        </button> */}
      </div>
    </div>
  );
};

export default ToneHuntBanner;
